module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/010-slovenia-9fff355610f491b0bd48808207c6515d.svg";